import { addNavMenuSection } from "@vendure/admin-ui/core";

export default [
  addNavMenuSection(
    {
      id: "newsletter",
      label: "Newsletter",
      items: [
        {
          id: "newsletter-subscriptions",
          label: "Anmeldungen",
          routerLink: ["/extensions/newsletter/anmeldungen"],
          icon: "envelope",
          requiresPermission: "UpdateSettings"
        }
      ]
    },
    "settings"
  )
];
